import React from "react";
import { Spinner } from "../../state-indicators";
import { connect } from "react-redux";
import withReportDataService from "../../../hoc/with-dataservice-consumer";
import "./page1-org-header.scss";
import { theme_dark, theme_light } from "../../../commonConstants";

class _OrgHeaderIFrame extends React.Component {
    _mounted = false;
    componentDidMount() {
        this._mounted = true;
        const { href, dataService, html } = this.props;

        if (html !== undefined) {
            this.setState({
                loading: false,
                error: false,
                header_html: html
            });

            return;
        }
        fetch(href, {
            headers: {
                ...dataService._authHeader().headers
            }
        })
            .then(resp => {
                if (!this._mounted) {
                    return;
                }
                if (resp.ok) {
                    return resp.text();
                }
                this.setState({
                    loading: false,
                    error: false
                });
                throw new Error("ERROR. Get organization header.");
            })
            .then(res => {
                if (!this._mounted) {
                    return;
                }
                this.setState({
                    loading: false,
                    error: false,
                    header_html: res
                });
            })
            .catch(err => {
                if (!this._mounted) {
                    return;
                }
                this.setState({
                    loading: false,
                    error: true,
                    header_html: undefined
                });
                console.error(err);
            });
    }
    componentWillUnmount() {
        this._mounted = false;
    }
    state = {
        loading: true,
        error: false,
        header_html: undefined
    };
    onLoad = () => {
        this.setState({ loading: false });
    };

    render() {
        let { loading, error, header_html } = this.state;
        return error ? null : (
            <div className="org-header-integrated">
                {header_html && (
                    <iframe
                        id="org-header"
                        src={`data:text/html;charset=utf-8,${encodeURIComponent(header_html)}`}
                        title="org header"></iframe>
                )}
                {loading ? <Spinner withCaption={false} small /> : null}
            </div>
        );
    }
}

const OrgHeaderIFrame = withReportDataService()(_OrgHeaderIFrame);

const OrgHeaderImg = props => {
    function onError(img) {
        img.style.display = "none";
    }
    return (
        <div className="org-header-image">
            <img src={props.src} alt="organization header" onError={e => onError(e.target)}></img>
        </div>
    );
};

class OrgHeader extends React.Component {
    render() {
        const { theme, orgHeader } = this.props;
        const { url_img, url_iframe } = orgHeader ?? {};
        let { html } = orgHeader ?? {};
        const wrapperClass = theme === theme_light ? "light-theme" : theme === theme_dark ? "dark-theme" : "";
        if (html !== undefined) {
            html = `<div class="${wrapperClass ?? ""}">${html}</div>`;
        }
        return (
            <div className="page1__header">
                {html || url_iframe ? (
                    <OrgHeaderIFrame href={url_iframe} html={html} wrapperClass={wrapperClass} />
                ) : url_img ? (
                    <OrgHeaderImg src={url_img} />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        orgHeader: state.reportApp.reportData.report.orgHeader,
        theme: state.reportApp.app.settings.theme
    };
};

export default connect(mapStateToProps)(OrgHeader);
